<template>
  <lego-modal-extend-v-2
    ref="modalUser"
    :title="!isEventSetting ? $t('title.addedAlarmUser') : $t('title.modifyNotification')"
    :width="!isEventSetting ? 1100 : 1200"
    :height="!isEventSetting ? 'auto' : 900"
    @beforeClose="handleClose"
    :customStyle="{
      body: {
        padding: '24px 0'
      }
    }"
  >
    <div class="add-user-modal" v-if="!isEventSetting">
      <div>
        <lego-dropdown
          v-model="searchType"
          :items="searchTypeCodes"
          :width="300"
          @update:modelValue="searchText = ''"
        />
        <lego-text-field
          :width="658"
          searchable
          v-model="searchText"
          :mutateInput="getMutateInput"
          :placeholder="t('page.eventStatus.inputSearch')"
          style="margin-left: 20px"
        />
      </div>
      <div class="list-select-table-wrap">
        <div class="select-list-wrap">
          <div class="select-list-header">{{ t('page.eventStatus.addrList') }}</div>
          <!--알림 주소록-->
          <c-scroll style="height: 237px">
            <ul class="select-list">
              <li
                v-for="(item, index) in addressBookItems"
                :key="index"
                :class="{ active: item.addressBookSq === selectedGroup.addressBookSq }"
              >
                <div class="select-item">
                  <div
                    class="select-item-title ellipsis"
                    v-lego-tooltip:ellipsis="item.addressBookName + '(' + item.memberCount + ')'"
                    @click="onSelectGroup(item)"
                  >
                    <span>{{ item.addressBookName }}</span>
                    <span> ({{ item.memberCount }})</span>
                  </div>
                  <lego-button
                    v-if="!item.selectDisable"
                    sm
                    @click="
                      addressBookSelect(item);
                      changeData();
                    "
                    style="
                      height: 24px;
                      min-width: 48px;
                      color: #2f3237;
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 500;
                      border: 1px solid #d1d3d7;
                    "
                    >{{ t('button.add') }}
                  </lego-button>
                  <!--추가-->
                </div>
              </li>
            </ul>
          </c-scroll>
        </div>
        <div class="table-wrap">
          <lego-paging-table
            ref="addUserModal"
            multiSelect
            selectAll
            isNotScrollX
            v-model="userSelected"
            :items="items"
            :headers="headers"
            :scrollMaxRow="6"
            :noSelectedShow="false"
            :selectActionControl="false"
            :isActionSelect="false"
            :selectMaxCnt="selectMaxItem"
            :messageMaxCnt="$t('page.eventStatus.notificationsTarget', { max: limitSelected })"
            @sort="onClickSort"
            @update:modelValue="changeData"
          >
          </lego-paging-table>
        </div>
      </div>
      <div class="batch-list-wrap">
        <div class="total-header">
          {{ t('page.eventStatus.selectedItem') }} <strong>{{ selected.length }}</strong>
        </div>
        <!--선택 항목 총-->
        <div class="batch-list">
          <c-scroll style="height: 100px">
            <lego-chip
              v-for="(item, index) in selected"
              :key="index"
              medium
              removable
              :itemData="item"
              @delete="
                deleteItem(item);
                changeData();
              "
            >
              <span :style="{ 'font-weight': item.type != 'USER' ? 'bold' : 'normal' }">{{
                item.type == 'USER' ? item.name : item.addressBookName
              }}</span>
              / {{ item.info }}
            </lego-chip>
          </c-scroll>
        </div>
      </div>
    </div>

    <div class="notification-target" v-if="isEventSetting">
      <alarm-user-setting
        ref="alarm"
        class="event-alarm__setting"
        :alarmInfos="notificationsModel"
        :isSmallSize="true"
        @user-selected="selectedUsers"
        @clickDeselection="removeNotification"
      />
      <notifications-table
        ref="notifications"
        :valueTmp="notificationsModel"
        :maxRowTable="9"
        :rules="rules"
        @remove-item="removeItem"
        @select-method="selectMethod"
      />
    </div>

    <template #footer>
      <lego-button @click="handleClose">{{ t('button.cancel') }}</lego-button>
      <!-- 취소 -->
      <lego-button @click="onConfirmClick" :disabled="isNoMethodSelected || !changedFieldData" main
        >{{ t('button.save') }}
      </lego-button>
      <!-- 확인 -->
    </template>
  </lego-modal-extend-v-2>
</template>

<script>
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n.mixin.js';
import NotificationsTable from '@/containers/event/eventSettings/components/NotificationsTable.vue';
import AlarmUserSetting from '@/containers/event/eventSettings/components/AlarmUserSetting.vue';
import LegoModalExtendV2 from '@/components/lego/extend/legoModalExtendV2.vue';
import validateFieldsMixin from '@/mixins/validateFields.mixin';
import { EVENT_LEVELS } from '@/containers/utils/constant.js';

export default {
  mixins: [i18nMixin, validateFieldsMixin],
  emits: ['userSelected', 'close:modal'],
  computed: {
    isNoMethodSelected() {
      return this.notificationsModel.some((item) => {
        return item.notificationMethods.some(
          (noti) => noti.eventLevel === this.eventLevelSet[0] && noti.sendMethod.length === 0
        );
      });
    },
    eventLevelSet() {
      if (!this.rules || this.rules.length === 0) return [];
      let result = [];
      EVENT_LEVELS.forEach((eventLevel) => {
        let event = this.rules.find((item) => item.eventLevel == eventLevel);
        if (event) {
          result.push(eventLevel);
        }
      });
      return result;
    },
    selected() {
      //console.log('this.addressBookModel = ', this.addressBookModel);
      let addressBooks = this.$util.replaceArr(this.addressBookModel, {
        addressBookSq: 'seq',
        addressBookName: 'name',
        info: 'info',
        memberCount: 'count',
        userName: 'userName'
      });
      let users = this.$util.replaceArr(this.userSelected, {
        userName: 'name',
        email: 'info',
        userResourceId: 'seq'
      });
      addressBooks.forEach((item) => {
        item.addressBookName = item.name;
        item.type = 'ADDRBOOK';
      });
      users.forEach((item) => {
        // item.addressBookName = '프로젝트 멤버';
        item.type = 'USER';
      });
      let result = addressBooks.concat(users);
      return result;
    },
    searchParam() {
      let param = '?page=0&size=0&sort=' + this.sort.sortDataField + ':' + this.sort.sortOrder;
      return param;
    },
    selectMaxItem() {
      return this.limitSelected - this.selected.length + this.userSelected.length;
    }
  },
  props: {
    isEventSetting: {
      type: Boolean,
      default: false
    },
    alarmInfos: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {
    NotificationsTable,
    AlarmUserSetting,
    LegoModalExtendV2
  },
  data() {
    return {
      validateFieldKey: 'addUser',
      usersSelected: [],
      notificationsModel: [],
      isDataChanged: false,
      // 검색영역
      searchTypeCodes: [
        { text: this.$t('page.eventStatus.name'), value: 'userName' },
        { text: this.$t('page.eventStatus.email'), value: 'email' },
        { text: this.$t('page.eventStatus.mobile'), value: 'mobile' },
        { text: this.$t('page.eventStatus.companyName'), value: 'companyName' }
      ],
      items: [],
      itemsTemp: [],
      searchType: 'userName',
      searchText: '',
      selectedGroup: {},
      addressBookItems: [],
      addressBookModel: [],
      userSelected: [],
      headers: [
        {
          text: this.$t('page.eventStatus.name'),
          value: 'userName',
          width: 140,
          defaultValue: '-',
          sortable: true
        }, // 이름
        {
          text: this.$t('page.eventStatus.email'),
          value: 'email',
          width: 140,
          defaultValue: '-',
          sortable: true
        }, // 이메일
        {
          text: this.$t('page.eventStatus.mobile'),
          value: 'mobile',
          defaultValue: '-',
          sortable: true
        }, // 휴대전화
        {
          text: this.$t('page.eventStatus.companyName'),
          value: 'companyName',
          defaultValue: '-',
          sortable: true
        } //회사명
      ],
      page: {
        rowsPerPage: 3,
        currentPage: 1,
        totalPages: 1,
        totalItems: 0
      },
      diabledItems: [],
      rowMenuItems: '',
      sort: {
        sortDataField: 'userName',
        sortOrder: 'asc'
      },
      chkUsers: [],
      limitSelected: 20
    };
  },
  async created() {
    if (!this.isEventSetting) {
      await this.getInitData();
    } else {
      this.notificationsModel = this.alarmInfos;
    }
    this.setFieldsBeforeModify();
  },
  methods: {
    selectMethod(data) {
      this.isDataChanged = true;
      this.selectedUsers(data);
    },
    removeItem(data) {
      this.$refs.alarm.deleteItem(data.selected);
    },
    removeNotification(selected) {
      if (selected.length === 0 && this.$refs.notifications !== undefined) {
        this.$refs.notifications.selected = [];
      }
    },
    selectedUsers(users) {
      if (this.notificationsModel.length !== users.length) this.isDataChanged = true;
      this.usersSelected = [];
      let lenNotificationList = this.notificationsModel.length - 1;
      users.forEach((item) => {
        for (let count = 0; count <= lenNotificationList; count++) {
          if (this.notificationsModel[count].seq == item.seq) {
            item.notificationMethods = this.notificationsModel[count].notificationMethods;
          }
        }
        for (let count = 0; count <= lenNotificationList; count++) {
          if (this.notificationsModel[count].recipientKey == item.seq) {
            item.notificationMethods = this.notificationsModel[count].notificationMethods;
          }
        }
        if (item.notificationMethods === undefined) {
          let _FATAL = { sendMethod: ['MAIL'] };
          let _WARNING = { sendMethod: ['MAIL'] };
          let _INFORM = { sendMethod: ['MAIL'] };

          item.notificationMethods = [
            { eventLevel: 'FATAL', ..._FATAL },
            { eventLevel: 'WARNING', ..._WARNING },
            { eventLevel: 'INFORM', ..._INFORM }
          ];
        }

        item.recipientName = item.name;
        item.recipientKey = item.seq;
        item.recipientType = item.type;
        if (item.type === 'USER') {
          item.userAdditionalInfo = {
            userEmail: item.info,
            userLanguage: '',
            userMobileTelNo: '',
            userTimezone: ''
          };
        } else {
          item.addrbookAdditionalInfo = {
            memberCount: item.count,
            userAdditionalInfo: [{ userName: item.userName }]
          };
        }
        this.usersSelected.push(item);
      });

      this.notificationsModel = this.$util.deepCopy(this.usersSelected);
    },
    changeData() {
      this.isDataChanged = true;
    },
    handleClose() {
      this.showMessageWhenChange(this.modalClose);
    },
    getMutateInput(text) {
      return this.$util.replaceEventAlarmText(text, this.searchType, this);
    },
    // sortable
    onClickSort(sortItem) {
      this.sort.sortDataField = sortItem.value;
      this.sort.sortOrder = sortItem.asc ? 'asc' : 'desc';
      // this.searchMembers(this.selectedGroup)
      if (['asc', 'desc'].includes(this.sort.sortOrder))
        this.items = this.items.sort((a, b) => {
          if (this.sort.sortOrder == 'asc') {
            return a[this.sort.sortDataField].localeCompare(b[this.sort.sortDataField]);
          } else {
            return b[this.sort.sortDataField].localeCompare(a[this.sort.sortDataField]);
          }
        });
    },

    // 사용자 검색
    searchMembers(item, cmd) {
      this.items = [];
      this.itemsTemp = [];
      if (item.addressBookSq === 999999) {
        this.getProjectMembers();
      } else {
        this.getAddressBookMembers(item, cmd);
      }
    },

    // 프로젝트 멤버 목록
    getProjectMembers() {
      this.$http.system
        .get(`/v1/console/address-books/accounts-members` + this.searchParam)
        .then((data) => {
          if (data.contents) {
            data.contents.forEach((item) => {
              item['companyName'] = item.company_name;
              item['userName'] = item.user_name;
              item['userResourceId'] = item.id;
            });
            this.items = data.contents;
            this.itemsTemp = data.contents;
          }
        });
    },

    // 주소록 멤버 목록
    getAddressBookMembers(item, cmd) {
      this.$http.system
        .get(
          `/v1/console/address-books/${item.addressBookSq}/address-book-users` + this.searchParam
        )
        .then((data) => {
          data.contents.forEach((item) => {
            item['companyName'] = item.company_name;
            item['userName'] = item.user_name;
            item['userResourceId'] = item.id;
          });
          this.items = data.contents.map((item) => _.omit(item, ['addressBookSq']));
          this.itemsTemp = data.contents;
          if (
            data.totalCount > 0 &&
            _.findIndex(this.addressBookModel, { addressBookSq: item.addressBookSq }) == -1
          ) {
            item.info = data.contents[0].userName;
            if (data.totalCount > 1) {
              item.info +=
                this.$t('label.other') + (data.totalCount - 1) + this.$t('label.otherperson');
            }
            item.userName = data.contents[0].userName;
            item.memberCount = data.totalCount;
            if (cmd == 'ADD') this.addressBookModel.push(item);
          }
        });
    },

    // 초기 데이타 셋팅
    async getInitData() {
      let promiseArr = [];
      let param = '?page=0&size=0&';
      promiseArr.push(this.$http.system.get(`/v1/console/address-books` + param));
      promiseArr.push(
        this.$http.system.get(
          `/v1/console/address-books/accounts-members` + param + '&sort=user_name:asc'
        )
      );

      await Promise.all(promiseArr).then((data) => {
        //console.log('address-book Data = ', data);
        this.addressBookItems = data[0].contents.filter((v) => v.memberCount > 0);
        this.addressBookItems.unshift({
          addressBookName: this.t('page.eventStatus.defaultGroup'),
          memberCount: data[1].totalCount,
          selectDisable: true,
          addressBookSq: 999999
        });
        if (data[1].contents) {
          data[1].contents.forEach((item) => {
            item['companyName'] = item.company_name;
            item['userName'] = item.user_name;
            item['userResourceId'] = item.id;
          });
          this.items = data[1].contents;
          this.itemsTemp = data[1].contents;
        }
        this.selectedGroup = this.addressBookItems[0];
        if (this.alarmInfos.length > 0) this.setNotifications();
      });
    },

    setNotifications() {
      this.notificationsModel = this.alarmInfos;
      this.alarmInfos.forEach((item) => {
        if (item.recipientType == 'ADDRBOOK') {
          let addressBook = {
            addressBookSq: parseInt(item.recipientKey),
            addressBookName: item.recipientName,
            info: this.nameCell(item),
            memberCount: item.addrbookAdditionalInfo.memberCount,
            userName:
              item.addrbookAdditionalInfo.userAdditionalInfo[0].userName ||
              item.addrbookAdditionalInfo.userAdditionalInfo[0].user_name
          };
          this.addressBookModel.push(addressBook);
        } else if (item.recipientType == 'USER') {
          let user = _.find(this.items, { userResourceId: item.recipientKey });
          this.userSelected.push(user);
        }
      });
    },

    nameCell(item) {
      let str = `${
        item.addrbookAdditionalInfo.userAdditionalInfo[0].userName ||
        item.addrbookAdditionalInfo.userAdditionalInfo[0].user_name
      }`;
      if (item.addrbookAdditionalInfo.memberCount > 1) {
        str += ` ${this.$t('label.other')} ${item.addrbookAdditionalInfo.memberCount - 1}${this.$t(
          'label.otherperson'
        )}`;
      }
      return str;
    },

    addressBookSelect(item) {
      //let chkCount =
      //if(this.addressBookModel.indexOf(item) > -1) {

      if (_.findIndex(this.addressBookModel, { addressBookSq: item.addressBookSq }) > -1) {
        window.app.$modal.open({
          rootId: 'app',
          type: 'alert',
          title: this.t('page.eventStatus.notice'),
          message: this.t('page.eventStatus.selectedAlarmGroup'),
          action: () => {
            //console.log('actionaction');
          }
        });
        return;
      }
      if (this.selected.length >= this.limitSelected) {
        window.app.$modal.open({
          rootId: 'app',
          type: 'alert',
          title: this.t('page.eventStatus.notice'),
          message: this.$t('page.eventStatus.notificationsTarget', { max: this.limitSelected }),
          action: () => {
            //console.log('actionaction');
          }
        });
        return;
      }
      this.selectedGroup = item;
      this.searchMembers(item, 'ADD');
    },

    onSelectGroup(item) {
      //console.log(item)
      this.$refs.addUserModal.$refs.table.clearErrorMessage();
      this.selectedGroup = item;
      this.searchText = '';
      this.searchMembers(item);
    },
    onConfirmClick() {
      // let notificationLen = this.userSelected.length;
      // if (notificationLen > 20) {
      //   this.$alert(this.t('page.eventStatus.notificationsRegister'));
      //   return;
      // }
      this.$emit('userSelected', !this.isEventSetting ? this.selected : this.notificationsModel);
      this.modalClose();
    },
    deleteItem(item) {
      if (item.type === 'ADDRBOOK') {
        let itemIndex = _.findIndex(this.addressBookModel, { addressBookSq: item.seq });
        this.addressBookModel.splice(itemIndex, 1);
      } else {
        let itemIndex = _.findIndex(this.userSelected, { userResourceId: item.seq });
        this.userSelected.splice(itemIndex, 1);
      }
      this.$refs.addUserModal.$refs.table.clearErrorMessage();
    },

    // onResetRows() {
    //   //console.log("[onResetRows]")
    //     this.userSelected = [];
    // },

    modalClose() {
      //console.log('close');
      this.$emit('close:modal');
    }
  },
  mounted() {
    this.$refs['modalUser'].open();
  },
  watch: {
    searchText: _.debounce(function (newVal, oldVal) {
      const filterList = this.itemsTemp.filter((item) => {
        let text = item[this.searchType];
        if (text != null) return text.toLowerCase().includes(newVal.toLowerCase());
      });
      this.items = filterList;
    }, 200)
  }
};
</script>

<style lang="scss">
.add-user-modal .simplebar-content {
  width: 100% !important;
}
</style>
<style lang="scss" scoped>
.notification-target {
  :deep(.lego-table .lego-table__control) {
    z-index: auto;
  }
}
.event-alarm__setting {
  :deep(.list-select-table-wrap) {
    margin-top: 0;
  }
}

.list-select-table-wrap {
  display: flex;
  align-items: normal;
  align-content: center;
  margin-top: 20px;

  .select-list-wrap {
    width: 300px;
    height: 268px;
    border: 1px solid #e4e5e7;
    border-radius: 4px;

    .select-list-header {
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      color: var(--dark);
      background-color: var(--color-ui-12);
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }

  .table-wrap {
    width: calc(700px - 20px);
    padding-left: 20px;
  }
}

.select-list {
  & > li {
    height: 33px;
    padding: 5px 20px;
    font-weight: 500 !important;
    font-style: normal !important;
    color: #2f3237;
    cursor: pointer;

    .select-item {
      display: flex;
    }

    /* .select-item:hover {
            background-color: var(--color-primary-tint-01);
        } */

    em {
      padding-left: 6px;
      font-style: normal;
    }

    /* &.active {
            color: var(--blue-with-a-hint-of-purple);
            background-color: rgba(54, 79, 199, 0.12);
        } */
  }

  & > li:hover {
    color: var(--blue-with-a-hint-of-purple);
    background-color: var(--color-primary-tint-01);
  }
}

.select-item-title {
  width: 81%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}

.batch-list-wrap {
  .total-header {
    padding: 20px 0 0 0;
  }

  .batch-list {
    min-height: 116px;
    margin: 8px 10px 0 0;
    padding: 8px 20px 20px;
    border-radius: 2px;
    border: solid 1px var(--color-ui-06);
    background-color: #fff;

    :deep .lego-chip__container {
      margin: 12px 10px 0 0 !important;
    }
  }
}

.active {
  color: #465dcb !important;
  background-color: var(--color-primary-tint-01);
}

:deep .left-divider:before {
  display: none !important;
}

:deep .lego-table__action-selected {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block !important;
    width: 1px;
    height: 10px;
    background: #bbbdc1;
  }
}

:deep .left-divider .lego-table__counter__per-page {
  display: none !important;
}
</style>
